import React, { useEffect, useState } from "react";
import clsx from "clsx";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import { IconUpload } from "@tabler/icons-react";
import { API_URL } from "utils/constants";

const MasterDataFormV2 = ({
  // title,
  apiUrl,
  initialData,
  fields = [],
  onSuccess,
  onError,
  onDelete,
  transformData,
}) => {
  const isUpdateMode = !!(initialData && initialData.id);

  // 🔹 **Inisialisasi formData dengan initialData saat mode edit**
  const [formData, setFormData] = useState({});

  // useEffect(() => {
  //   if (isUpdateMode) {
  //     setFormData(initialData);
  //   } else {
  //     const defaultValues = {};
  //     fields.forEach((field) => {
  //       defaultValues[field.name] = field.type === "checkbox" ? false : "";
  //     });
  //     setFormData(defaultValues);
  //   }
  // }, [initialData, fields, isUpdateMode]);

  useEffect(() => {
    const defaultValues = {};
    fields.forEach((field) => {
      if (field.type === "checkbox") {
        defaultValues[field.name] = false;
      } else if (field.type === "multiselect") {
        defaultValues[field.name] = [];
      } else {
        defaultValues[field.name] = field.defaultValue || "";
      }
    });

    const hasInitialData = initialData && Object.keys(initialData).length > 0;
    if (hasInitialData) {
      const prefill = { ...defaultValues };

      Object.keys(initialData).forEach((key) => {
        const field = fields.find((f) => f.name === key);
        if (key === "is_active") {
          prefill[key] = String(initialData[key]);
        } else if (field && field.type === "date" && initialData[key]) {
          // Convert date string to Date object for DatePicker
          prefill[key] = new Date(initialData[key]);
        } else if (
          field &&
          field.isPrice &&
          initialData[key] !== null &&
          initialData[key] !== undefined
        ) {
          // For price fields, store raw value and formatted display
          const rawValue = String(initialData[key]);
          prefill[key] = rawValue;
          prefill[`${key}_display`] = formatNumber(rawValue);
        } else {
          prefill[key] = initialData[key];
        }
      });

      // ❗️Override khusus untuk category_ids
      if (
        (!initialData.category_ids || initialData.category_ids.length === 0) &&
        Array.isArray(initialData.categories)
      ) {
        prefill["category_ids"] = initialData.categories.map((cat) => cat.id);
      }

      // Set all_workdays based on workdays
      const workdays = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ];
      const allWorkdaysChecked = workdays.every((day) => prefill[day] === true);
      prefill.all_workdays = allWorkdaysChecked;

      setFormData(prefill);
    } else {
      setFormData(defaultValues);
    }
  }, [initialData, fields]);

  // const [selectedFile, setSelectedFile] = useState(null);

  // const { createData, loading: creating } = useCreateData(apiUrl);
  // const { updateData, loading: updating } = useUpdateData(
  //   `${apiUrl}/${initialData?.id}`
  // );

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imagePreview, setImagePreview] = useState(
    initialData?.image_url || ""
  ); // ✅ Simpan gambar lama

  const isFieldVisible = (field) => {
    if (typeof field.showWhen === "function") {
      return field.showWhen(formData);
    }
    return true;
  };

  const visibleFields = fields.filter(isFieldVisible);

  const isRequiredField = (field) =>
    typeof field.required === "function"
      ? field.required(formData)
      : field.required;

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const stringValue = String(value);
    const number = stringValue.replace(/\D/g, "");
    return new Intl.NumberFormat("id-ID").format(Number(number));
  };

  const unformatNumber = (value) => {
    return value.replace(/\./g, "");
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    // 🔹 Untuk field price atau min_price atau field dengan isPrice: true
    const field = fields.find((f) => f.name === name);
    if (["price", "min_price"].includes(name) || field?.isPrice) {
      const formatted = formatNumber(value); // untuk tampil
      const raw = unformatNumber(formatted); // untuk dikirim
      setFormData((prev) => ({
        ...prev,
        [name]: raw,
        [`${name}_display`]: formatted, // ← simpan tampilan terformat
      }));
      return;
    }

    // 🔹 Field lain
    setFormData((prev) => {
      const newData = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };

      // Handle all_workdays logic
      if (name === "all_workdays") {
        const workdays = [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ];
        workdays.forEach((day) => {
          newData[day] = checked;
        });
      } else if (
        [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ].includes(name)
      ) {
        // Check if all workdays are checked
        const workdays = [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ];
        const allChecked = workdays.every((day) => newData[day] === true);
        newData.all_workdays = allChecked;
      }

      return newData;
    });

    if (type === "file") {
      const file = files[0];
      if (file) {
        setFormData((prev) => ({
          ...prev,
          [name]: file,
        }));
        setImagePreview(URL.createObjectURL(file));
      }
    }
  };

  // const handleChangeV3 = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));

  //   if (type === "file") {
  //     const file = files[0];

  //     if (file) {
  //       setSelectedFile(file); // ✅ Simpan file baru
  //       setImagePreview(URL.createObjectURL(file)); // ✅ Tampilkan preview
  //     }
  //   }
  // };

  // const handleChangeV2 = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));

  //   if (type === "file") {
  //     const file = files[0];

  //     if (file) {
  //       setSelectedFile(file);
  //       setImagePreview(URL.createObjectURL(file)); // ✅ Tampilkan preview file baru
  //     }
  //   }
  // };

  // const handleChangeV1 = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]:
  //       type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //   }));

  //   if (type === "file") {
  //     setSelectedFile(files[0]?.name || "");
  //   }
  // };

  const handleSelectChange = (selectedOption, field) => {
    if (field.loadOptions) {
      // For async select, store the object
      setFormData((prev) => ({
        ...prev,
        [field.name]: selectedOption,
      }));
    } else {
      // For regular select, store the value
      setFormData((prev) => ({
        ...prev,
        [field.name]: selectedOption ? selectedOption.value : "",
      }));
    }
  };

  const handleDateChange = (date, field) => {
    setFormData((prev) => ({
      ...prev,
      [field.name]: date,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    // 🔹 Client-side validation
    const missingFields = visibleFields.filter(field => {
      if (!isRequiredField(field)) return false;
      const value = formData[field.name];
      if (field.type === "checkbox") return false; // Checkbox usually not 'required' in this sense
      if (Array.isArray(value)) return value.length === 0;
      return value === null || value === undefined || value === "";
    });

    if (missingFields.length > 0) {
      const fieldLabels = missingFields.map(f => f.label).join(", ");
      if (onError) {
        onError({ message: `Please fill in required fields: ${fieldLabels}` });
      }
      return;
    }

    setIsSubmitting(true);
    try {
      let dataToProcess = { ...formData };
      if (transformData && typeof transformData === "function") {
        dataToProcess = transformData(dataToProcess);
      }

      const submitData = new FormData();

      // 🔹 Tambahkan semua field kecuali `image` jika tidak ada file baru
      // Object.keys(formData).forEach((key) => {
      //   if (
      //     formData[key] !== null &&
      //     formData[key] !== undefined &&
      //     key !== "image_url" // ✅ Jangan kirim `image_url`
      //   ) {
      //     if (
      //       formData.recorded_at &&
      //       typeof formData.recorded_at === "string" &&
      //       formData.recorded_at.includes("T")
      //     ) {
      //       const [date, time] = formData.recorded_at.split("T");
      //       formData.recorded_at = `${date} ${time}:00`; // ✅ format: 2025-03-31 13:13:00
      //     }

      //     submitData.append(key, formData[key]);
      //   }
      // });

      Object.keys(dataToProcess).forEach((key) => {
        const value = dataToProcess[key];
        const field = visibleFields.find((f) => f.name === key);

        // khusus array seperti category_ids[], insurances[], facilities[], deductions[]
        if (Array.isArray(value)) {
          // Handle arrays of objects (multiselect) vs arrays of primitives
          if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null) {
            // Array of objects - extract the value property for each object
            value.forEach((obj, idx) => {
              const val = obj.value !== undefined ? obj.value : obj;
              submitData.append(`${key}[${idx}]`, val);
            });
          } else {
            // Array of primitives
            value.forEach((val, idx) => {
              submitData.append(`${key}[${idx}]`, val);
            });
          }
        } else if (
          value !== null &&
          value !== undefined &&
          key !== "image_url" &&
          key !== "all_workdays" // Skip frontend-only field
        ) {
          // khusus untuk datetime field
          if (
            key === "recorded_at" &&
            typeof value === "string" &&
            value.includes("T")
          ) {
            const [date, time] = value.split("T");
            submitData.append(key, `${date} ${time}:00`);
          } else if (value instanceof Date) {
            // khusus untuk date field (start_date, end_date, dll) - format dalam timezone lokal
            const year = value.getFullYear();
            const month = String(value.getMonth() + 1).padStart(2, "0");
            const day = String(value.getDate()).padStart(2, "0");
            const formattedDate = `${year}-${month}-${day}`; // Format: YYYY-MM-DD dalam timezone lokal
            submitData.append(key, formattedDate);
          } else if (
            typeof value === "object" &&
            value !== null &&
            value.value !== undefined
          ) {
            // For async select objects
            submitData.append(key, value.value);
          } else {
            // Convert boolean to 0/1 for checkbox fields
            if (field && field.type === "checkbox") {
              submitData.append(key, value ? 1 : 0);
            } else if (typeof value === "boolean") {
              submitData.append(key, value ? 1 : 0);
            } else if (field && field.type === "time" && value) {
              // For time fields, ensure H:i format
              const timeStr = String(value);
              const trimmedTime = timeStr.split(":").slice(0, 2).join(":");
              submitData.append(key, trimmedTime);
            } else if (value instanceof File) {
              // Handle file upload with its specific key
              submitData.append(key, value);
            } else {
              submitData.append(key, value);
            }
          }
        }
      });



      // 🔹 Jika update, tambahkan `_method: "PUT"`
      if (isUpdateMode) {
        submitData.append("_method", "PUT");
      }

      const token = localStorage.getItem("token"); // 🔥 Ambil token untuk autentikasi
      const url = isUpdateMode
        ? `${API_URL}${apiUrl}/${initialData?.id}`
        : `${API_URL}${apiUrl}`;

      const response = await fetch(url, {
        method: "POST", // Gunakan POST karena ada `_method: PUT`
        body: submitData,
        headers: {
          Authorization: `Bearer ${token}`, // 🔥 Tambahkan token di sini
        },
      });

      const result = await response.json();

      if (response.ok) {
        onSuccess(result);
      } else {
        onError(result);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      if (onError) onError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="d-flex flex-column">
      <div className="action-sheet-content flex-grow-1">
        {visibleFields.map((field) => (
          <div className="row mb-3 align-items-center" key={field.name}>
            <label className="col-sm-4 col-form-label d-flex justify-content-end">
              {field.label} {isRequiredField(field) && <span className="text-danger ms-1">*</span>}:
            </label>
            <div className="col-sm-8">
              {field.type === "custom" && field.render && (
                field.render({
                  value: formData[field.name],
                  onChange: (val) => setFormData(prev => ({ ...prev, [field.name]: val })),
                  formData
                })
              )}

              {["text", "number", "password", "email", "tel"].includes(
                field.type
              ) && (
                <div>
                  <input
                    type={field.type}
                    className={clsx("form-control")}
                    name={field.name}
                    value={
                      ["price", "min_price"].includes(field.name) ||
                      field.isPrice
                        ? formData[field.name] || "" // Gunakan nilai murni tanpa titik
                        : formData[field.name] || ""
                    }
                    onChange={handleChange}
                    required={isRequiredField(field)}
                    min={field.min}
                    step={field.step}
                  />
                  {/* Tampilkan preview formatted di bawah input untuk price/min_price atau field dengan isPrice */}
                  {(["price", "min_price"].includes(field.name) ||
                    field.isPrice) &&
                    formData[field.name] && (
                      <small className="text-muted mt-1 d-block">
                        Preview: {formatNumber(formData[field.name])}
                      </small>
                    )}
                </div>
              )}

              {field.type === "textarea" && (
                <textarea
                  className="form-control"
                  name={field.name}
                  rows={field.rows || 3}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  required={isRequiredField(field)}
                />
              )}

              {field.type === "select" &&
                (field.onInputChange || field.loadOptions ? (
                  <AsyncSelect
                    loadOptions={field.loadOptions}
                    onInputChange={field.onInputChange}
                    value={
                      field.value ||
                      (field.loadOptions
                        ? formData[field.name]
                        : field.options?.find(
                            (opt) => opt.value === formData[field.name]
                          ) || "")
                    }
                    onChange={
                      field.onChange ||
                      ((selected) => handleSelectChange(selected, field))
                    }
                    isSearchable
                    isClearable={!isRequiredField(field)}
                    placeholder={field.placeholder || `Pilih ${field.label}`}
                    isLoading={field.isLoading}
                    defaultOptions={field.defaultOptions || field.options}
                    cacheOptions={false}
                  />
                ) : (
                  <Select
                    options={field.options}
                    value={
                      field.options?.find(
                        (opt) => opt.value === formData[field.name]
                      ) || ""
                    }
                    onChange={(selected) => handleSelectChange(selected, field)}
                    isSearchable
                    isClearable={!isRequiredField(field)}
                    placeholder={field.placeholder || `Pilih ${field.label}`}
                  />
                ))}

              {/* {field.type === "multiselect" && (
                <Select
                  options={field.options}
                  isMulti
                  closeMenuOnSelect={false}
                  value={field.options.filter((opt) =>
                    (formData[field.name] || []).includes(opt.value)
                  )}
                  onChange={(selected) => {
                    const selectedValues = selected.map((item) => item.value);
                    setFormData((prev) => ({
                      ...prev,
                      [field.name]: selectedValues,
                    }));
                  }}
                  placeholder={`Select ${field.label}`}
                />
              )} */}

              {field.type === "multiselect" &&
                (field.onInputChange || field.loadOptions ? (
                  <AsyncSelect
                    loadOptions={field.loadOptions}
                    onInputChange={field.onInputChange}
                    isMulti
                    closeMenuOnSelect={false}
                    value={
                      // If formData contains objects (pre-selected), use them directly
                      // Otherwise, filter from defaultOptions or options
                      Array.isArray(formData[field.name]) &&
                      formData[field.name].length > 0 &&
                      typeof formData[field.name][0] === 'object'
                        ? formData[field.name]
                        : (Array.isArray(field.defaultOptions) ? field.defaultOptions :
                           Array.isArray(field.options) ? field.options : [])?.filter((opt) =>
                            (formData[field.name] || []).includes(opt.value)
                          )
                    }
                    onChange={
                      field.onChange ||
                      ((selected) => {
                        const selectedValues = selected.map(
                          (item) => item.value
                        );
                        setFormData((prev) => ({
                          ...prev,
                          [field.name]: selectedValues,
                        }));
                      })
                    }
                    placeholder={field.placeholder || `Select ${field.label}`}
                    isLoading={field.isLoading}
                    defaultOptions={field.defaultOptions || field.options}
                    cacheOptions={false}
                  />
                ) : (
                  <Select
                    options={field.options}
                    isMulti
                    closeMenuOnSelect={false}
                    value={field.options?.filter((opt) =>
                      (formData[field.name] || []).includes(opt.value)
                    )}
                    onChange={(selected) => {
                      const selectedValues = selected.map((item) => item.value);
                      setFormData((prev) => ({
                        ...prev,
                        [field.name]: selectedValues,
                      }));
                    }}
                    placeholder={field.placeholder || `Select ${field.label}`}
                  />
                ))}

              {/* {field.type === "radio" &&
                field.options?.map((option) => (
                  <div
                    className="form-check form-check-inline"
                    key={option.value}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name={field.name}
                      value={option.value}
                      checked={formData[field.name] === option.value}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">{option.label}</label>
                  </div>
                ))} */}
              {field.type === "radio" &&
                field.options?.map((option) => (
                  <div
                    className="form-check form-check-inline"
                    key={option.value}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name={field.name}
                      value={option.value}
                      checked={formData[field.name] === option.value}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">{option.label}</label>
                  </div>
                ))}

              {field.type === "checkbox" && (
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name={field.name}
                    checked={formData[field.name] || false}
                    onChange={handleChange}
                  />
                  <label className="form-check-label">{field.label}</label>
                </div>
              )}

              {field.type === "date" && (
                <DatePicker
                  selected={formData[field.name]}
                  onChange={(date) => handleDateChange(date, field)}
                  className="form-control"
                  dateFormat="yyyy-MM-dd"
                  required={isRequiredField(field)}
                />
              )}

              {field.type === "file" && (
                <div className="input-group">
                  <input
                    type="file"
                    className="form-control"
                    name={field.name}
                    onChange={handleChange}
                    required={isRequiredField(field)}
                  />
                  <span className="input-group-text">
                    <IconUpload size={18} />
                  </span>
                </div>
              )}

              {field.type === "datetime-local" && (
                <input
                  type="datetime-local"
                  className="form-control"
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  required={isRequiredField(field)}
                />
              )}

              {field.type === "time" && (
                <input
                  type="time"
                  className="form-control"
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  required={isRequiredField(field)}
                />
              )}

              {field.type === "color" && (
                <input
                  type="color"
                  className="form-control form-control-color"
                  name={field.name}
                  value={formData[field.name] || "#000000"}
                  onChange={handleChange}
                  title="Choose your color"
                />
              )}

              {/* {selectedFile && (
                <p className="mt-1 text-muted">File: {selectedFile}</p>
              )} */}
            </div>
          </div>
        ))}

        {imagePreview && (
          <div className="row mb-3 align-items-center">
            <label className="col-sm-4 col-form-label d-flex justify-content-end">
              Image Preview:
            </label>
            <div className="col-sm-8">
              <img
                src={imagePreview}
                alt="Preview"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />
            </div>
          </div>
        )}
      </div>
      {/* print json */}
      {/* <div className="row mb-3 align-items-center">
        <label className="col-sm-4 col-form-label d-flex justify-content-end">
          JSON:
        </label>
        <div className="col-sm-8">
          <pre>{JSON.stringify(formData, null, 2)}</pre>
        </div>
      </div> */}
      <div className="form-group mt-auto d-grid gap-2">
        <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Processing...
            </>
          ) : (
            isUpdateMode ? "Update" : "Create"
          )}
        </button>
        {isUpdateMode && onDelete && (
          <button
            type="button"
            className="btn btn-danger btn-block"
            onClick={onDelete}
          >
            Delete
          </button>
        )}
      </div>
    </form>
  );
};

export default MasterDataFormV2;
